import { Loader } from '@openx/components-core/lib/Loader/Loader';
import { PageNotFound } from '@openx/components-core/lib/PageNotFound/PageNotFound';
import { HeaderActions } from '@openx/components-header/HeaderActions/HeaderActions';
import { PageHeader } from '@openx/components-header/PageHeader';
import { LalSegmentDetails } from '@openx/components-segment/lib/LalSegmentDetails/LalSegmentDetails';
import { useSegmentContext } from '@openx/components-segment/lib/utils/context/SegmentContext';
import { useShowLal } from '@openx/components-segment/lib/utils/useShowLal';
import { useCanGoBack } from '@openx/utils/hooks/useCanGoBack';
import { useTranslation } from 'react-i18next';
import { Navigate, useNavigate, useParams } from 'react-router';
import { DetailsHeaderAlerts } from './DetailsHeaderAlerts';
import { useHeaderActions } from './hooks/useHeaderActions';

export function LalSegmentDetailsPage() {
  const { t } = useTranslation();
  const showLal = useShowLal();

  const { lalSegmentUid } = useParams();
  const navigate = useNavigate();

  const { useLalSegmentFetch } = useSegmentContext();
  const { lalSegment, loading: lalSegmentLoading } = useLalSegmentFetch(lalSegmentUid ?? '');
  const { actions: headerActions } = useHeaderActions({ lalSegment });
  const canGoBack = useCanGoBack();

  const onGoBack = () => {
    if (canGoBack) {
      navigate(-1);
    } else {
      navigate('/segments/lookalike');
    }
  };

  if (!showLal) {
    return <Navigate to="/segments/audience" />;
  }

  if (lalSegmentLoading) {
    return <Loader />;
  }

  if (!lalSegment || !lalSegmentUid) {
    return <PageNotFound appName={'OpenXSelect'} />;
  }

  const pageTitle = `${t('Details:')} ${lalSegment.lookalike_name}`;

  return (
    <PageHeader
      title={pageTitle}
      goBack={onGoBack}
      render={() => <HeaderActions actions={headerActions} />}
      titlePrefix={'OpenXSelect'}
    >
      <DetailsHeaderAlerts lalSegment={lalSegment} />
      <LalSegmentDetails lalSegment={lalSegment} />
    </PageHeader>
  );
}
